import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Spinner from '../../components/Spinner';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { formatDate, formatNumber } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';
import { PURCHASE_PATH, addPurchaseCost, deletePurchase, downloadPurchaseReceipt, getPagePurchases, removePurchaseCost, uploadPurchaseExcelFile } from '../../api/purchaseApi';
import { SUPPLIER_PATH, getPageSuppliers } from '../../api/supplierApi';
import { RxCross1 } from 'react-icons/rx';
import { pageModel } from '../../utils/model';
import { FaReceipt } from "react-icons/fa";
import SupplierPicker from '../../components/supplier/SupplierPicker';
import { setPurchaseSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import { FaArrowRotateLeft } from 'react-icons/fa6';
import ChargeModal from '../../components/ChargeModal';

const PurchaseListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [purchasePage, setPurchasePage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${PURCHASE_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${PURCHASE_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.purchase)

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    const [supplierPage, setSupplierPage] = useState({
        content: []
    });
    const [supplierQuery, setSupplierQuery] = useState('')
    const [searchTimerSupplier, setSearchTimerSupplier] = useState();
    const pendingApiCallSupplier = useApiProgress('get', `${SUPPLIER_PATH}/page`, false)
    const [isOpenChargeModal, setIsOpenChargeModal] = useState(false)
    const [selected, setSelected] = useState()

    const searchingSupplier = async (params) => {
        if (searchTimerSupplier) clearTimeout(searchTimerSupplier);
        let timer = setTimeout(() => {
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(res.data)
                })
        }, 500);
        setSearchTimerSupplier(timer);
    }

    const onClickLoadMoreSupplier = () => {
        if (!supplierPage.last) {
            loadSuppliers({ search: supplierQuery, lastId: supplierPage.content[supplierPage.content.length - 1]?.id })
        }
    }

    const loadSuppliers = (params) => {
        !pendingApiCallSupplier &&
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        loadPurchases({ size: 20, ...searchParams, supplierId: searchParams.supplier?.id })
        loadSuppliers({ size: 20 })
    }, [])

    const onLoadMore = () => {
        if (!purchasePage.last) {
            loadPurchases({ ...searchParams, supplierId: searchParams.supplier?.id, lastId: purchasePage.content[purchasePage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, supplierId: searchParams.supplier?.id })
    }, [searchParams])

    useEffect(() => {
        !isFirstRender && searchingSupplier({ search: supplierQuery })
    }, [supplierQuery])

    const loadPurchases = (params) => {
        !pendingApiCall &&
            getPagePurchases(params)
                .then(res => {
                    setPurchasePage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPagePurchases(params)
                .then(res => {
                    setPurchasePage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deletePurchase(deleteId)
            .then(res => {
                setIsOpen(false)
                setPurchasePage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== deleteId) }))
                toast.success('Silindi')
                setDeleteId()
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const onClickProcessPurchaseCost = (purchase) => {
        if (purchase.charged) {
            removePurchaseCost(purchase.id)
                .then(res => {
                    setPurchasePage(prevState => (
                        {
                            ...prevState,
                            content: prevState.content.map(p => {
                                if (p.id === res.data.id) return res.data
                                else return p
                            }
                            )
                        }
                    ))
                    toast.success('Satın alım hesaptan çıkarıldı')
                }).catch(err => {
                })
        } else {
            addPurchaseCost(purchase.id)
                .then(res => {
                    setPurchasePage(prevState => (
                        {
                            ...prevState,
                            content: prevState.content.map(p => {
                                if (p.id === res.data.id) return res.data
                                else return p
                            }
                            )
                        }
                    ))
                    toast.success('Satın alım hesaba işlendi')
                }).catch(err => {
                })
        }
        setIsOpenChargeModal(false)

    }

    const onClickReceipt = (purchase) => {
        downloadPurchaseReceipt(purchase.id)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = "" + purchase.supplierName + " satın-alma #" + purchase.id + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl uppercase'>
                    Satın alımlar
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Satın Alım</label>}
                    variant='green'
                    onClick={() => nav('/purchase/add')}
                />
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-2/12'>
                            <div className='flex justify-between items-center'>
                                <div className='flex'>
                                    <span>Tedarikçi Adı</span>
                                    <span>{pendingApiCallSupplier && <Spinner />}</span>
                                </div>
                                {
                                    searchParams.supplier &&
                                    <span onClick={() => dispatch(setPurchaseSearchParamsAction({ key: "supplier", value: null }))}>
                                        <RxCross1 />
                                    </span>
                                }
                            </div>
                        </th>
                        <th className='p-2 w-1/12'>Tarih</th>
                        <th className='p-2 w-2/12'>Fatura No</th>
                        <th className='p-2 w-1/12'>Tutar</th>
                        <th className='p-2 w-1/12'>Miktar</th>
                        <th className='p-2 w-1/12'>Kullanıcı</th>
                        <th className='p-2 w-1/12'>Hesaba işlendi mi?</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-top sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => dispatch(setPurchaseSearchParamsAction({ key: "id", value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            {/* SUPPLIER SEARCH */}
                            <SupplierPicker
                                state={searchParams.supplier}
                                setState={(value) => dispatch(setPurchaseSearchParamsAction({ key: 'supplier', value }))}
                                query={supplierQuery}
                                setQuery={setSupplierQuery}
                                page={supplierPage}
                                //onClickClear={() => dispatch(setPurchaseSearchParamsAction({ key: 'supplier', value: null }))}
                                onClickLoadMore={() => onClickLoadMoreSupplier()}
                            />
                        </td>
                        <td className='px-2 gap-x-1'></td>
                        <td className='px-2 gap-x-1'>
                            <Input
                                name='invoiceNumber'
                                placeholder='Fatura no girin..'
                                value={searchParams.invoiceNumber}
                                onChange={e => dispatch(setPurchaseSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {
                        purchasePage.content.map((purchase, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {purchase.id} </td>
                                <td className='p-2'>{purchase.supplierName} </td>
                                <td className='p-2'>{formatDate(purchase.purchaseDate)}</td>
                                <td className='p-2'>{purchase.invoiceNumber}</td>
                                <td className='p-2'>{formatNumber(purchase.cost)} {purchase.currency}
                                </td>
                                <td className='p-2'>{purchase.rollSize} top - {formatNumber(purchase.quantity)} m </td>
                                <td className='p-2'>{purchase?.user}</td>
                                <td className='p-2 text-center'>
                                    <input
                                        type='checkbox'
                                        checked={purchase.charged}
                                        //defaultChecked={purchase.charged}
                                        onChange={() => {
                                            setSelected(purchase)
                                            setIsOpenChargeModal(true)
                                        }}
                                    />
                                </td>
                                <td className='p-2 items-center'>
                                    {
                                        !purchase.formerRecord &&
                                        <>
                                            {
                                                <div className='flex gap-x-3'>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-gray-600 duration-150'>
                                                        <FaReceipt onClick={() => onClickReceipt(purchase)} />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/purchase/edit/${purchase.id}`)}>
                                                        <AiFillEdit />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-gray-600 duration-150'>
                                                        <FaArrowRotateLeft onClick={() => nav(`/returnment/purchase/${purchase.id}`)} />
                                                    </span>
                                                    {
                                                        !purchase.charged &&
                                                        <>
                                                            <span
                                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                                onClick={() => {
                                                                    setIsOpen(true)
                                                                    setDeleteId(purchase.id)
                                                                }}
                                                            >
                                                                <AiFillDelete />
                                                            </span>
                                                        </>
                                                    }
                                                </div>
                                            }

                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={purchasePage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <ChargeModal
                isOpen={isOpenChargeModal}
                closeModal={() => setIsOpenChargeModal(false)}
                onSubmit={() => onClickProcessPurchaseCost(selected)}
            />
        </div >
    )
}

export default PurchaseListPage